import { getValidToken } from '../utils/tokenUtils';

/**
 * Fetches AI-generated General Exception suggestions for the given test result IDs.
 * Returns a map of { [testResultId]: [{ issueKey, title, score, browseUrl }] }
 */
export const fetchGeneralExceptionSuggestions = async (testResultIds, testExecutionId) => {
  if (!testResultIds || testResultIds.length === 0) return {};

  const token = await getValidToken();
  if (!token) throw new Error('Ingen giltig inloggningssession. Logga in på nytt.');

  const params = new URLSearchParams();
  testResultIds.forEach(id => params.append('testResultIds', id));
  params.append('testExecutionId', testExecutionId);

  const res = await fetch(`/api/ai-suggestions?${params.toString()}`, {
    headers: { Authorization: `Bearer ${token}` },
  });

  if (!res.ok) {
    const text = await res.text().catch(() => null);
    const err = new Error(`Kunde inte hämta AI-förslag (${res.status}).` + (text ? ` - ${text}` : ''));
    err.status = res.status;
    throw err;
  }

  return res.json();
};
